import { useQuery } from '@tanstack/react-query'

import { getEnrollmentDepartureChecklist } from '../../../api/enrollments/get-enrollment-departure-checklist'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import useEnrollment from '../../../lib/hooks/use-enrollment'

export default function ClientChildDepartureChecklistPage() {
  const { enrollment } = useEnrollment()

  const { data, isPending, error } = useQuery({
    queryKey: ['departure-checklist', enrollment?.id],
    queryFn: () => getEnrollmentDepartureChecklist(enrollment.id),
    enabled: !!enrollment?.id
  })

  if (error) return <ItemNotFound title="Aucune page trouvée" />
  if (isPending) return <LoadingScreen />

  return <div dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
}
